import { useController, UseControllerProps } from "react-hook-form";
import { TextFieldProps, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import TextField from "components/inputs/TextField";

export type TextFieldControlProps = {
  name: UseControllerProps["name"];
  rules?: UseControllerProps["rules"];
  endIcon?: ReactNode;
  handleChange?: (value: string, onChange: (newValue: string) => void) => void;
  label?: string;
  maskType?: "time";
  maskProps?: { mask: string };
  startIcon?: ReactNode | string;
  onNumberValueChange?: (value: number) => void;
  hideHelperText?: boolean;
  stackSx?: SxProps<Theme>;
} & Omit<TextFieldProps, "label" | "name" | "onChange">;

const TextFieldControl = ({ name, rules, ...props }: TextFieldControlProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({ defaultValue: "", name, rules });

  return (
    <TextField
      {...props}
      {...field}
      error={error}
    />
  );
};

export default TextFieldControl;
